<template>
	<div>
		<a href="#" data-reveal-id="confirmSubscriptionResetModal" class="button alert expand tiny" @click="resetCounter">
			Reset
		</a>

		<div id="confirmSubscriptionResetModal" class="reveal-modal text-center small" data-reveal aria-labelledby="modalTitle" aria-hidden="true" role="dialog">

			<div class="row">
				<div class="columns">
					  <h3 id="modalTitle text-alert">Are you sure you want to reset this Club's Stripe Subscription?</h3>
					  <p class="lead">This will mean the club will be prompted to set up a new Subscription if they come back on to the system.</p>
					  <p>Normally we'd say be very careful, but we save the ID so if there's a mistake let us know and we can get it back 👍</p>
				</div>
			</div>

			<div class="row mtl">
				<div class="columns"><button  class="button alert expand" :disabled="disabled" @click="resetSubscriptionId">{{message}}</button></div>
			</div>
		  <a class="close-reveal-modal" aria-label="Close">&#215;</a>
		</div>
	</div>
</template>

<script>

export default {
  name: 'ResetClientStripeSubscriptionId',
  data() {
    return {
      loading: false,
      countDownTime: 3,
      counter: 10,
      timer: {},
    };
  },

  methods: {
    resetCounter() {
      this.counter = this.countDownTime;
      clearInterval(this.timer);
      this.countdown();
    },

    countdown() {
      this.timer = setInterval(() => {
        if (this.counter > 0) {
          this.counter -= 1;
        } else {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    async resetSubscriptionId() {
      this.loading = true;
      await this.$store.dispatch('RESET_CLIENT_STRIPE_SUBSCRIPTION_ID');
      this.loading = false;
    },

  },

  computed: {
    secondsRemaining() {
      return this.counter;
    },

    disabled() {
      return this.counter != 0 || this.loading;
    },
    message() {
      if (this.loading) {
        return 'Please wait..';
      }
      return this.secondsRemaining > 0 ? `Please wait ${this.secondsRemaining} seconds` : 'Reset Stripe Subscription';
    },
  },
  beforeMount() {

  },

  mounted() {

  },
  created() {
    this.counter = this.countDownTime;
  },

};
</script>

<style scoped>

[v-cloak] {
	display: none;
}

</style>
